import React from "react";
import styled from 'styled-components';
import BgImage from '../Images/walletBg.png';

const Root = styled.div`
position:fixed;
top:0;
bottom:0;
background-image:url(${BgImage});
width:28%;
height:530px;
top:50px;
background-size:100% 100%;
background-repeat:no-repeat;
background-position:center;
z-index:1000;
left:36%;
padding:${(p) => p.theme.spacing.sm};
display:flex;
flex-direction:column;

@media(min-width:1600px){
  height:680px;
}

@media(max-width:${(p) => p.theme.screen.md}){
  width:40%;
  left:30%;
}
@media(max-width:${(p) => p.theme.screen.sm}){
  width:50%;
  left:25%;
}
@media(max-width:${(p) => p.theme.screen.xs}){
  width:60%;
  left:20%;
}
@media(max-width:${(p) => p.theme.screen.xxs}){
  width:75%;
  left:12.5%;
}
@media(max-width:${(p) => p.theme.screen.xxxs}){
  width:85%;
  left:7.5%;
}
`;
const OverLay = styled.div`
 position:fixed;
 width:100%;
 height:100vh;
 top:0;
 bottom:0;
 background-color:rgba(0,0,0,0.8);
 left:0px;
 z-index:100;
`;

const Heading = styled.div`
font-size:${(p) => p.theme.font.size.lg};
font-weight:${(p) => p.theme.font.weight.bold};
text-align:center;
@media(min-width:1600px){
  font-size:${(p) => p.theme.font.size.xl};
}
`;
const Button = styled.button`
border:1px solid #3f1c4a;
background:none;
margin-top:${(p) => p.theme.spacing.sm};
color:${(p) => p.theme.colors.white};
font-family:${(p) => p.theme.font.family.Lato};
display:flex;
justify-content:space-between;
align-items:center;
padding:${(p) => p.theme.spacing.xxs} ${(p) => p.theme.spacing.xxs} ${(p) => p.theme.spacing.xxs} ${(p) => p.theme.spacing.xs};
border-radius:${(p) => p.theme.radius.xs};
cursor:pointer;
@media(min-width:1600px){
  font-size:${(p) => p.theme.font.size.md};
  padding:${(p) => p.theme.spacing.xs};
}
`;
const IconWrapper = styled.div`
width:32px;
height:32px;
background-color:${(p) => p.theme.colors.white};
display:flex;
align-items:center;
justify-content:center;
border-radius:${(p) => p.theme.radius.xs};
@media(min-width:1600px){
  width:40px;
  height:40px;
}
`;
const Icon = styled.img`
width:20px;
@media(min-width:1600px){
  width:24px;
}
`;
const ConfirmPopup = ({setShowPopup,showPopup, onClickFun, text}) =>{

    return(
      <OverLay>
        <Root onClick={(e) => {e.stopPropagation()}}>
          <Heading>{text}</Heading>
          {/* <Button onClick={onClickFun}>
              confirm 
          </Button> */}
          <Button onClick={onClickFun}>
              Confirm 
          </Button>
        </Root>
      </OverLay>
    )
};

export default ConfirmPopup;